import React, { Component } from 'react';

export default class GoalResultItem extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {

        }

        this.numberWithCommas = this.numberWithCommas.bind(this);
        this.convertToDisplay = this.convertToDisplay.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    numberWithCommas(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    convertToDisplay(number) {

        let type = this.props.identity.type;

        let endText = "";
        switch (type) {
            case 'MNY':
                endText += '$' + this.numberWithCommas(parseFloat(number).toFixed(2));
                break;
            case 'INT':
                let newNum = parseFloat(number);
                if (newNum === NaN) {
                    endText += '';
                } else {
                    endText += this.numberWithCommas(parseFloat(number).toFixed(0));
                }
                break;
            case 'PCT':
                let newNum1 = parseFloat(number);
                if (newNum1 === NaN) {
                    endText += '';
                } else {
                    endText += this.numberWithCommas(parseFloat(number).toFixed(1)) + '%';
                }
                break;
            default:
                endText += this.numberWithCommas(number);
        }
        return endText;
    }

    render() {

        let me = this.props.identity;
        let mainGoal = this.props.mainGoal;

        let circleStyle = {}
        if (me.isOver) {
            if ((me.actualVal >= me.goalVal && !mainGoal.useUnder) || (me.actualVal <= me.goalVal && mainGoal.useUnder)) {
                circleStyle.backgroundColor = '#49ca75';
            } else {
                circleStyle.backgroundColor = '#fe0101';
            }
        }

        let barFillStyle = {};
        let bottomTextStyle = {};
        if ((me.actualVal >= me.goalVal && !mainGoal.useUnder) || (me.actualVal <= me.goalVal && mainGoal.useUnder)) {
            barFillStyle.backgroundColor = '#49ca75';
            bottomTextStyle.color = '#49ca75';
        } else {
            barFillStyle.backgroundColor = '#fe0101';
            bottomTextStyle.color = '#fe0101';
        }

        barFillStyle.width = me.fillPerc + '%';

        let displayPercentage = me.fillPerc;
        if (displayPercentage < 0) {
            displayPercentage = 0;
        } else if (displayPercentage > 100) {
            displayPercentage = 100;
        }

        return (
            <div className="goal-result-item-outer">
                <div className="goal-result-item-icon-container">
                    <div className="goal-result-item-icon" style={circleStyle}>{Math.floor(displayPercentage) + "%"}</div>
                </div>
                <div className="goal-result-item-name-container">
                    <div className="goal-result-item-date">{me.dateRangeString}</div>
                    <div className="goal-result-item-bar">
                        <div className="goal-result-item-bar-inner">
                            <div className="goal-result-item-bar-back"></div>
                            <div className="goal-result-item-bar-fill" style={barFillStyle}></div>
                        </div>
                    </div>
                </div>
                <div className="goal-result-item-numbers-container">
                    <div className="goal-result-item-top">{this.convertToDisplay(me.actualVal) + ' /'}</div>
                    <div className="goal-result-item-bottom" style={bottomTextStyle}>{this.convertToDisplay(me.goalVal.toFixed(2))}</div>
                </div>
            </div>
        );
    }
}